// src/components/HowItWorks.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './HowItWorks.css';

const blocks = [
  {
    number: 1,
    title: 'Convolution Block 1',
    features: [
      'Edge detection (64 filters)',
      'Pattern identification',
      'Local texture features',
    ],
  },
  {
    number: 2,
    title: 'Convolution Block 2',
    features: [
      'Shape recognition (128 filters)',
      'Structural patterns',
      'Geometric features',
    ],
  },
  {
    number: 3,
    title: 'Convolution Block 3',
    features: [
      'Complex malware signatures (256 filters)',
      'Section arrangement patterns',
      'Entropy distribution',
    ],
  },
  {
    number: 4,
    title: 'Convolution Block 4',
    features: [
      'Family-specific patterns (512 filters)',
      'Semantic features',
      'Classification layer',
    ],
  },
];

const HowItWorks: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="how-it-works">
      <div className="hiw-container">
        <h2 className="section-title">How it works</h2>
        <p className="hiw-subtitle">
          Four convolutional blocks extract increasingly complex patterns from binary visualizations
        </p>
        <div className="blocks-grid" ref={ref}>
          {blocks.map((block, idx) => (
            <motion.div
              key={block.number}
              className="block-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
            >
              <div className="block-number">{block.number}</div>
              <h3 className="block-title">{block.title}</h3>
              <ul className="block-features">
                {block.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;